import { onAuthStateChanged } from "firebase/auth";
import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "./api";
import { auth } from "./firebase";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

// 業務委託者かどうかはバックエンドが member.freee_id の有無で判定する（issue #85）。
// プロフィールで freee_id を変えると区分も変わるので、ログイン時だけでなく保存後にも取り直す。
const fetchContractorStatus = async (user) => {
  const encodedEmail = encodeURIComponent(user.email);
  const response = await api.get(`${process.env.REACT_APP_API_URL}/users/${encodedEmail}`);
  return response.data.is_contractor || false;
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isContractor, setIsContractor] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);

      if (user) {
        try {
          setIsContractor(await fetchContractorStatus(user));
        } catch (error) {
          console.error("業務委託者ステータスの取得に失敗しました:", error);
          if (error.response && error.response.status === 500) {
            alert("ユーザー情報の取得に失敗しました。しばらく待ってから再度アクセスして下さい。");
          }
          setIsContractor(false);
        }
      } else {
        setIsContractor(false);
      }

      setLoading(false);
    });

    return unsubscribe;
  }, []);

  // 区分を取り直す。失敗したときは今の区分を変えずに null を返す。
  const refreshContractorStatus = useCallback(async () => {
    if (!currentUser) {
      return null;
    }
    try {
      const status = await fetchContractorStatus(currentUser);
      setIsContractor(status);
      return status;
    } catch (error) {
      console.error("業務委託者ステータスの再取得に失敗しました:", error);
      return null;
    }
  }, [currentUser]);

  return (
    <AuthContext.Provider value={{ currentUser, isContractor, refreshContractorStatus }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
